<template>
  <b-modal
    id="login-modal"
    ref="modal"
    title=""
    hide-footer
    hide-header
    centered
  >
    <div class="header">
      <span class="close-icon" @click="closeModal">
        <img src="@/assets/svg/close.svg" aria-label="close" />
      </span>

      <h3>авторизация</h3>

      <h5>{{ authText }}</h5>
    </div>

    <form ref="form" class="modal-form" @submit.stop.prevent="submit">
      <b-form-group label-for="phone-input" :invalid-feedback="invalidPhone">
        <b-form-input
          id="phone-input"
          placeholder="Email"
          v-model="$v.item.email.$model"
          :class="{ 'is-invalid': isInvalidPhone, 'is-valid': !isInvalidPhone }"
          :state="validateState($v.item.email)"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-for="password-input"
        :invalid-feedback="invalidPassword"
      >
        <b-form-input
          id="password-input"
          placeholder="Пароль"
          v-model="$v.item.password.$model"
          :state="validateState($v.item.password)"
          required
          :class="{
            'is-invalid': isInvalidPassword,
            'is-valid': !isInvalidPassword,
          }"
          type="password"
        ></b-form-input>
      </b-form-group>
    </form>

    <b-button
      class="button button-green button-green-bg"
      type="submit"
      :disabled="disabledBtn"
      @click="submit"
      onclick="ym(108239013,'reachGoal','login')"
      >ВОЙТИ</b-button
    >

    <div
      class="p-wrapper d-flex align-items-center justify-content-between w-100 mt-4 pl-3 pr-3"
    >
<!--      <p class="m-fz" v-b-modal.registration-modal @click="closeModal">-->
<!--        Зарегистрироваться-->
<!--      </p>-->

      <p
        v-b-modal.reset-password-modal
        @click="closeModal"
        style="font-size: 14px"
      >
        Забыли пароль?
      </p>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { mapMutations } from "vuex";
import {
  helpers,
  maxLength,
  minLength,
  required,
} from "vuelidate/lib/validators";

const number = helpers.regex(
  "number",
  /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/,
);
const email = helpers.regex("email", /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/);

export default {
  props: ["authText", "authPhone"],

  mixins: [validationMixin],

  validations: {
    item: {
      phone: {
        minLength: minLength(17),
        maxLength: maxLength(17),
      },
      email: {
        required,
        minLength: minLength(4),
        email,
      },
      password: {
        required,
      },
    },
  },

  data() {
    return {
      item: {
        phone: "",
        email: "",
        password: "",
      },
      isInvalidPhone: false,
      isInvalidPassword: false,
      invalidPhone: "Некорректное поле",
      invalidPassword: "Некорректное поле",
    };
  },

  computed: {
    disabledBtn() {
      if (this.$v.item.$anyError) return true;
    },
  },

  methods: {
    ...mapMutations({
      saveUser: "saveUser",
      saveToken: "saveToken",
    }),

    putPlaceholder() {
      if (this.item.phone.length < 2) {
        this.item.phone = "+7";
      }
    },

    resetModal() {
      this.$v.$reset();

      ((this.item.phone = ""),
        (this.item.email = ""),
        (this.item.password = ""),
        (this.isInvalidPhone = false),
        (this.isInvalidPassword = false),
        (this.invalidPhone = "Некорректное поле"),
        (this.invalidPassword = "Некорректное поле"));

      this.$bvModal.hide("login-modal");
    },

    closeModal() {
      this.$v.$reset();

      ((this.isInvalidPhone = false),
        (this.isInvalidPassword = false),
        (this.item.phone = ""),
        (this.item.email = ""),
        (this.item.password = ""),
        (this.invalidPhone = "Некорректное поле"),
        (this.invalidPassword = "Некорректное поле"));

      this.$bvModal.hide("login-modal");
    },

    validateState(item) {
      const { $dirty, $error } = item;
      return $dirty ? !$error : null;
    },

    getUser(token) {
      axios
        .get(
          "user/account",
          {},
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "access-control-allow-origin": "*",
              Authorization: "Bearer " + localStorage.getItem("token-bockarev"),
            },
          },
        )
        .then((response) => {
          this.saveUser(response.data.data);
          window.location.href = "/office";
        })
        .catch((error) => {
          if (error.response.data.message) {
            this.$emit("getErrorText", error.response.data.message);

            this.$bvModal.show("error-modal");
          }
        });
    },

    submit() {
      this.$v.item.$touch();

      if (this.$v.item.$anyError) return false;

      axios
        .post(
          "auth/login",
          {
            email: this.item.email,
            password: this.item.password,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "access-control-allow-origin": "*",
            },
          },
        )
        .then((response) => {
          ym(108239013, "reachGoal", "login_send");

          this.resetModal();
          axios.defaults.headers.authorization =
            "Bearer " + response.data.access.token;

          this.getUser(response.data.access.token);
          this.saveToken(response.data.access.token);
          localStorage.setItem("token-bockarev", response.data.access.token);
        })
        .catch((error) => {
          if (
            error.response.data.message ===
            "Некорректный логин или пароль. Проверьте, пожалуйста, правильность ввода данных."
          ) {
            this.$emit("getErrorText", error.response.data.message);

            this.closeModal();
            this.$bvModal.show("error-modal");
          }
          if (error.response.data.message) {
            this.$emit("getErrorText", error.response.data.message);

            this.closeModal();
            this.$bvModal.show("error-modal");
          }
          if (error.response.data.errors.email) {
            this.isInvalidPhone = true;
            this.invalidPhone = error.response.data.errors.email[0];
          }
          if (error.response.data.errors.password) {
            this.isInvalidPassword = true;
            this.invalidPassword = error.response.data.errors.password[0];
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.button {
  margin-top: 25px;
  width: 100%;
  border: 1px solid $black !important;

  &:hover {
    opacity: 0.8 !important;
  }

  @media (max-width: 576px) {
    margin-top: 20px;
  }
}

.header {
  margin-bottom: 30px;
}

h3 {
  margin-bottom: 28px !important;
}

.modal-form {
  padding: 0px !important;
}

a {
  color: #fbd6a1;
  transition: 0.6s all;
}

p {
  font-family: $regular;
  cursor: pointer;
  transition: 0.5s all;
  color: #fbd6a1;
  transition: 0.6s all;
  text-decoration: underline !important;

  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 400px) {
    margin-bottom: 6px;
  }
}

.p-wrapper {
  @media (max-width: 400px) {
    flex-direction: column;
  }

  .m-fz {
    font-size: 16px;
  }
}
</style>
